// @ts-nocheck
export default "> * > *";
